import type { ThemeWithoutTokens } from '../theme.types';

export const controlTokens = (theme: ThemeWithoutTokens) =>
  ({
    // typo
    controlLetterSpacing: theme.typography.letterSpacing.m,
    controlTextColor: theme.colors.body.text,
    controlBackgroundColor: theme.colors.body.background,
    controlFontFamily: theme.typography.fontFamily.regular,
    controlFontSize: theme.typography.fontSize.s,
    controlLineHeight: theme.typography.lineHeight.s,
    controlFontWeight: theme.typography.fontWeight.normal,
    controlPlaceholderTextColor: theme.palette.grey400,
    // spacing
    controlPaddingY: `${10 / 16}rem`,
    controlPaddingX: theme.space.component.x.m,
    controlBorderRadius: theme.radiuses.m,
    controlBorderColor: theme.palette.grey300,
    controlBorderWidth: '1px',

    // hover
    controlHoverBorderColor: theme.palette.grey400,

    // focus
    controlFocusBorderColor: theme.colors.primary.normal,
    controlFocusBorderAdditionalWidth: '1px',
    controlFocusShadowColor: theme.colors.primary.alpha,
    controlFocusShadowSpread: theme.space.component.x.xs,
    controlFocusShadowTransitionTime: '0.1s',
    controlFocusShadowTransitionFunction: 'ease-out',

    // disabled
    controlDisabledBorderAdditionalWidth: '1px',
    controlDisabledBorderColor: theme.palette.grey300,
    controlDisabledBackgroundColor: theme.palette.grey100,
    controlDisabledTextColor: theme.colors.body.text,

    // prefix/suffix
    controlPrefixSuffixPaddingX: theme.space.component.x.s,
    controlPrefixSuffixSlotWidth: theme.space.component.x.xl,

    // errored
    controlErroredBorderColor: theme.colors.danger.normal,
    controlErroredFocusShadowColor: theme.colors.danger.alpha,

    // valid
    controlValidIconColor: theme.colors.success.normal,
  }) as const;
